import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Por favor completa todos los campos');
      return;
    }

    try {
      setLoading(true);
      await login(email, password);
      toast.success('¡Bienvenido de vuelta!');
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.detail || 'Error al iniciar sesión';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-20 min-h-screen bg-[#FAFAF9] flex items-center justify-center" data-testid="login-page">
      <div className="w-full max-w-md px-6 py-16">
        <div className="text-center mb-12">
          <Link to="/">
            <h1 
              className="text-4xl font-light tracking-tight text-[#1C1917] mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Aliglam
            </h1>
          </Link>
          <p className="text-[#A8A29E]">Iniciar sesión en tu cuenta</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors"
              placeholder="tu@email.com"
              data-testid="email-input"
            />
          </div>

          <div>
            <label className="block text-sm text-[#57534E] mb-2">
              Contraseña
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-[#E7E5E4] focus:outline-none focus:border-[#BA7B7C] transition-colors pr-12"
                placeholder="••••••••"
                data-testid="password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-[#A8A29E] hover:text-[#57534E]"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
            <div className="text-right mt-2">
              <Link 
                to="/forgot-password" 
                className="text-sm text-[#BA7B7C] hover:text-[#A36566] transition-colors"
                data-testid="forgot-password-link"
              >
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="login-submit"
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
        </form>

        <p className="text-center text-[#57534E] mt-8">
          ¿No tienes cuenta?{' '}
          <Link to="/register" className="text-[#BA7B7C] hover:text-[#A36566] transition-colors">
            Regístrate
          </Link>
        </p>

        <div className="mt-8 pt-8 border-t border-[#E7E5E4]">
          <Link 
            to="/admin/login" 
            className="block text-center text-sm text-[#A8A29E] hover:text-[#57534E] transition-colors"
          >
            Acceso administrador
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
